



























import { Component, Vue } from 'vue-property-decorator'
import { env } from '@ivy/fts/envInfo/envInfo'
import * as shareApi from '../api/shareApi'

@Component
export default class extends Vue {
  reportList: object[] = []
  async mounted() {
    await env.init()
    env.type === 'wx' && (await shareApi.share())
    await this.reportData()
  }
  // 处理时间,只要年月日
  getTime(value) {
    let index = value.indexOf(' ')
    let time = value.substring(0, index)
    return time
  }
  // 修改替换负号为BR
  changeScore(value) {
    if (value < 0) {
      return 'BR' + -value
    } else {
      return value
    }
  }
  // 获取历史报告数据
  async reportData() {
    let { data } = await shareApi.requireGet('/api/m-course/lexile/results')
    this.reportList = data.items
  }
  // 跳转到蓝思对照表
  toLexile() {
    window.location.href = `${
      window.location.origin
    }/act2/reimsAssess/lexile?_hideShareButton=1`
  }
  // 跳转到具体测评结果页
  toResult(id) {
    window.location.href = `${
      window.location.origin
    }/act2/reimsAssess/result?test_id=${id}&_hideShareButton=1`
  }
}
